import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToChucTieuChuanSanXuat } from 'src/app/shared/ToChucTieuChuanSanXuat.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class ToChucTieuChuanSanXuatService extends BaseService{
    list: ToChucTieuChuanSanXuat[] | undefined;
    list001: ToChucTieuChuanSanXuat[] | undefined;
    formData!: ToChucTieuChuanSanXuat;

    displayColumns001: string[] = ['STT', 'DanhMucTieuChuanSanXuatID','DienTich','SanLuong','Note', 'Save'];
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "ToChucTieuChuanSanXuat";
    }
}

